<ng-container *ngIf="!editMode; else editForm">
  <dl *ngIf="condition">
    <dt>
      {{ label | translate }}
    </dt>
    <dd>
      <span *ngIf="isEmpty(value); else spanElement"
            class="not-filled">
        {{ 'APP.GENERAL.NOT_FILLED' | translate }}
      </span>
      <ng-template #spanElement>
        <ng-container *ngIf="!dropdown; else dropdownValue">
          <span>{{ value }}</span>
        </ng-container>
        <ng-template #dropdownValue>
          <span>{{ label + '.' + value | translate }}</span>
        </ng-template>
      </ng-template>
      <ng-content select="[fieldHolderContent]"></ng-content>
    </dd>
  </dl>
</ng-container>

<ng-template #editForm>
  <ng-content></ng-content>
</ng-template>
